module.exports = __webpack_public_path__ + "static/media/road.5265a681.jpg";